(function () {
  function init() {
    var track = document.querySelector('.product__images--mobile-slider .product__slides');
    var dotsWrap = document.querySelector('[data-mobile-dots]');
    if (!track || !dotsWrap) return;

    var slides = track.querySelectorAll('.product__slide');
    if (slides.length < 2) return;

    dotsWrap.innerHTML = '';
    var dots = [];
    slides.forEach(function () {
      var dot = document.createElement('span');
      dot.className = 'product__mobile-dot';
      dotsWrap.appendChild(dot);
      dots.push(dot);
    });
    dots[0].classList.add('is-active');

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
        raf = null;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
